import FontLoader from 'components/font';
import type React from 'react';
import { useEffect, useRef } from 'react';
import DefaultFontLoader from '../../font/DefaultFontLoader.tsx';
import { DOWNLOADED_FONTS } from 'components/editor/grid/reduxStore/defaultTextDefaultValue';
import { useEditorConfig } from 'components/editor/GridDndEditor/Block/Text/EditorConfigs';
import { EditorMenu } from 'components/editor/EditorMenu/EditorMenu';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentId } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import { EditorInsights } from 'components/Insights/Insights.tsx';

const DocumentBuilderHeader: React.FC = () => {
  const contentId = useAppSelector(selectContentId);

  const headerWrapperRef = useRef<HTMLDivElement>(null);
  const { setIsConfigLoaded } = useEditorConfig();

  useEffect(() => {
    const el = headerWrapperRef.current;
    if (!el) return;

    const observer = new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty('--editor-header-height', `${entry.contentRect.height}px`);
    });

    observer.observe(el);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty('--editor-header-height');
    };
  }, []);

  const defaultTextStylingFonts = DOWNLOADED_FONTS.map((font) => ({
    path: font.path,
  }));

  const editorConfigHandler = () => {
    setIsConfigLoaded(true);
  };

  return (
    <div className="editor-header-wrapper" ref={headerWrapperRef}>
      <EditorMenu />
      <EditorInsights />
      <DefaultFontLoader defaultFonts={defaultTextStylingFonts} />
      <FontLoader contentId={contentId} editorConfigHandler={editorConfigHandler} />
    </div>
  );
};

export default DocumentBuilderHeader;
